__turbopack_context__.v({
  "card": "oZ7p-q_card",
  "container": "oZ7p-q_container",
  "content": "oZ7p-q_content",
  "eod-section": "oZ7p-q_eod-section",
  "how-it-works": "oZ7p-q_how-it-works",
  "img": "oZ7p-q_img",
  "recommend-bolt-description": "oZ7p-q_recommend-bolt-description",
  "section": "oZ7p-q_section",
  "video-wrapper": "oZ7p-q_video-wrapper",
});
